import {Badge, Box, Button, css, InputBase, Paper, Stack, styled, TextField} from '@mui/material';
import {CustomStyledPaper, StyledButtonLetterProps, StyledFilterRootProps} from './types';

const StyledFilterRoot = styled(Stack)<StyledFilterRootProps>`
	width: 100%;
	padding: 12px 16px;
	gap: 12px;
	box-shadow: 0px 4px 22px 0px #33333314;
	${({theme, $customBackgroundColor}) => css`
		background-color: ${$customBackgroundColor ?? theme.colors.gray['10Percent']};
	`}

	${({theme}) => css`
		${theme.breakpoints.up('sm')} {
			padding: 12px 32px;
		}
	`}

	${({$disableShadow}) =>
		$disableShadow &&
		css`
			box-shadow: none;
		`}

	${({$isNewHistoryPage, theme}) =>
		$isNewHistoryPage &&
		css`
			box-shadow: none;
			background-color: transparent;
			padding: 0;

			${theme.breakpoints.up('sm')} {
				padding: 0;
			}
		`}
`;

const StyledFilterSearch = styled<CustomStyledPaper>(Paper)`
	padding: 3px 5px 3px 12px;
	border-radius: 21px;
	gap: 8px;
	display: flex;
	align-items: center;
	width: 100%;
	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
`;

const StyledFilterInputBase = styled(InputBase)`
	flex: 1;

	.MuiInputBase-input {
		padding-top: 5px;
		height: 24px;
	}
`;

const StyledButtonLetter = styled(Button)<StyledButtonLetterProps>`
	border-radius: 4px;
	width: 40px;
	min-width: 40px;
	height: 40px;

	font-size: 0.875rem;
	font-weight: 400;
	${({theme}) => css`
		color: ${theme.colors.brand.primary.blue};
	`};

	${({theme, $active}) =>
		$active &&
		css`
			background-color: ${theme.colors.brand.primary.blue};
			color: ${theme.colors.brand.primary.white};
			&:hover {
				background-color: ${theme.colors.brand.primary.blue};
				color: ${theme.colors.brand.primary.white};
			}
		`};
`;

const StyledButton = styled(Button)`
	height: 40px;
	font-size: 1rem;
	font-weight: 600;
	padding: 3px 8px;
	position: relative;

	.MuiBadge-badge {
		right: 0;
		top: 0;
		transform: translate(30%, -50%);

		min-width: 20px;
		padding: 0 6px;
	}

	.MuiBadge-badge:empty {
		display: none;
	}

	.MuiBadge-badge.MuiBadge-invisible {
		display: none;
	}

	${({theme}) => css`
		box-shadow: none;
		background-color: ${theme.colors.light.primary['10Percent']};
		color: ${theme.colors.light.primary.main};
		&:hover {
			box-shadow: none;
			background-color: ${theme.colors.light.primary['10Percent']};
			color: ${theme.colors.light.primary.main};
		}
	`}
`;

const StyledContentButton = styled(Stack)`
	width: 100%;
	border-radius: 99px;
	padding: 3px 8px;
`;

const StyledTextField = styled(TextField)`
	border-radius: 21px;
	gap: 8px;
	display: flex;
	align-items: center;
	width: 100%;
	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	background-color: ${({theme}) => theme.palette.background.paper};
	& > .MuiOutlinedInput-root {
		width: 100%;
		padding: 3px 5px 3px 12px !important;
		& fieldset {
			padding: 0;
			border: none;
		}

		&:hover fieldset {
			border-color: none;
		}

		&.Mui-focused fieldset {
			border-color: none;
		}

		input {
			padding-top: 5px;
			padding: 6px 8px 5px !important;
		}
	}
`;

const StyledBoxItem = styled(Box)`
	width: 100%;
	padding: 8px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledBadge = styled(Badge)`
	.MuiBadge-badge {
		font-weight: 600;
	}
`;

export {
	StyledFilterRoot,
	StyledFilterSearch,
	StyledFilterInputBase,
	StyledButtonLetter,
	StyledButton,
	StyledContentButton,
	StyledTextField,
	StyledBoxItem,
	StyledBadge,
};
